import React, { useState } from 'react';
import ProjectPopup from './ProjectPopup';
import styles from './Projects.module.css';
import oldWebsiteImage from '../pictures/oldWebsite.png';
import matrix from '../pictures/matrix.jpg';
import webshop from '../pictures/webshop.jpg';
import peaksonfoot from '../pictures/peaksonfoot.png';

const projects = [
  {
    id: 1,
    title: 'My first website',
    description: "After starting studying biology in highschool, I realized that I have to change paths - \
    so I went to informatics class. Excel and Word bored me but creating websites fascinated me. \
    I felt like I created something. So two years later, I bought my first domain and deployed my first actual \
    website on Github Pages using raw HTML and CSS.",
    imageUrl: oldWebsiteImage,
    githubUrl: 'https://github.com/krisztiangal/oldWebsite',
    liveUrl: 'https://oldwebsite.krisztian.fi',
  },
  {
    id: 2,
    title: 'My home server',
    description: 'I was interested in technology from a very young age. Having an old, almost useless laptop lying \
    around (that I only used to try out different Linux distros), I had the idea of turning \
    it into a home server. I installed Ubuntu Server on it and started configuring it. Two days later, I installed \
    Ubuntu server on it again, because the best way to learn is to make mistakes. Now I have my own outline server, website, and \
    cloud storage running on it. It taught me (and is still teaching me after every power outage) a lot about Linux, Docker and server \
    administration in general. Only downside being the depth of this rabbit hole called homelabbing.',
    imageUrl: matrix,
    //githubUrl: 'https://github.com/your-username/project-two',
    //liveUrl: 'https://project-two.your-domain.com',
  },
  {
    id: 3,
    title: 'Webshop',
    description: "My uni friend built a webshop using Django and asked me to create a better design for it. \
    I started doing the CSS part when I was met with some utterly strange class names and IDs. About halfway \
    through the renaming process the friend told me that it is called Bootstrap and it actually makes designing \
    simpler and more efficient. So I went back to the original names, and learned how Bootstrap works. Since that, \
    I started reading documentation.... just kidding. I am still too lazy. (Live demo coming soon)",
    imageUrl: webshop,
    /*githubUrl: 'https://github.com/your-username/project-three',
    liveUrl: 'https://project-three.your-domain.com',*/
  },
  {
    id: 4,
    title: 'PeaksOnFoot',
    description: 'To practice my skills with React and refresh my JavaScript knowledge, I wanted to make a more \
    complex web app. I chose to fuse it with one of my favourite hobbies: mountaineering. So I created Bösenstein \
    project: a site where you can make a wishlist of mountains you plan to climb and track which ones you have \
    already summited. You can also upload new ones, or update existing ones with your own photos. Midway through \
    the process I realized that this project will exceed my knowledge - but this is how we learn the quickest, right? \
    I kept on adding features, and thinking about an Android app. But running all that on my own laptop-server sounds \
    silly, so I migrated everything to Google Firebase and set up my own domain and business email: peaksonfoot.com. \
    But then if I am already on Firebase, why not use their other \
    offerings? ...so now it is a full-fledged web app with Google OAuth, embedded maps, translation and many more features. Now I have \
    to market it, and start working on the mobile app.',
    imageUrl: peaksonfoot,
    liveUrl: 'https://peaksonfoot.com',
  },
  /*{
    id: 5,
    title: 'Project Five',
    description: 'Detailed description of Project Five. Explain the technologies used, the challenges faced, and the purpose of the project.',
    imageUrl: 'https://via.placeholder.com/400x300.png?text=Project+Five',
    githubUrl: 'https://github.com/your-username/project-five',
    liveUrl: 'https://project-five.your-domain.com',
  },
  {
    id: 6,
    title: 'Project Six',
    description: 'Detailed description of Project Six. Explain the technologies used, the challenges faced, and the purpose of the project.',
    imageUrl: 'https://via.placeholder.com/400x300.png?text=Project+Six',
    githubUrl: 'https://github.com/your-username/project-six',
    liveUrl: 'https://project-six.your-domain.com',
    },*/
];

function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);

  const handleOpenPopup = (project) => {
    setSelectedProject(project);
  };

  const handleClosePopup = () => {
    setSelectedProject(null);
  };

  return (
    <div className={styles.projectsContainer}>
      <h1 className={styles.subheader}>My Projects</h1>
      <div className={styles.projectsGrid}>
        {projects.map((project) => (
          <div
            key={project.id}
            className={styles.projectCard}
            onClick={() => handleOpenPopup(project)}
          >
            <div className={styles.imageContainer}>
                <img src={project.imageUrl} alt={project.title} className={styles.projectImage} />
            </div>
            <h3 className={styles.projectTitle}>{project.title}</h3>
          </div>
        ))}
      </div>
      {selectedProject && (
        <ProjectPopup project={selectedProject} onClose={handleClosePopup} />
      )}
    </div>
  );
}

export default Projects;
